<template>
  <div>
    <template>
      <van-form @submit="onSubmit">
        <!-- 企业搜索选择框 -->
        <van-field
            v-if="!isHidden"
            v-model="companySearch"
            label="企业名称"
            placeholder="请输入企业名称搜索"
            clearable
        >
          <template #label>
            <span class="center-span">企</span>
            <span class="center-span">业</span>
            <span class="center-span">名</span>
            <span class="center-span">称</span>
          </template>
          <template #button>
            <van-button
                size="small"
                :style="{ background: $store.state.themeInfo.themeColor, borderRadius: '5px', border: 'none', color: '#fff' }"
                @click="searchCompany"
                :disabled="companySearch.length < 2"
                native-type="button"
            >
              <van-icon name="search" />
            </van-button>
          </template>
        </van-field>

        <!-- 企业选择下拉列表 - 修复黑屏问题 -->
        <van-popup
            v-model="showCompanyList"
            position="bottom"
            round
            :style="{ height: '40%' }"
            get-container="body"
        >
          <van-picker
              show-toolbar
              title="请选择企业"
              :columns="companyList"
              @confirm="onSelectCompany"
              @cancel="showCompanyList = false"
              :visible-item-count="5"
          />
        </van-popup>

        <van-field
            v-model="form.phone"
            required-model="form.phone"
            required
            label="手机号"
            placeholder="手机号"
            type="digit"
            :error-message="phoneErrorMsg"
            maxlength="11"
            @input="phoneErrorMsg = ''"
            :rules="[{ required: true, message: '请填写正确手机号',pattern : phoneRules, trigger: 'onChange' }]"
        >
          <template #label>
            <span>手</span>
            <span>机</span>
            <span>号</span>
          </template>
        </van-field>
        <van-field
            v-model="form.verifyCode"
            center
            required
            :rules="[{ required: true, message: '请输入验证码', trigger: 'onChange' }]"
            clearable
            label="短信验证码"
            :maxlength="6"
            type="digit"
            placeholder="请输入短信验证码"
        >
          <template #button>
            <van-button
                size="small"
                :style="{ background: $store.state.themeInfo.themeColor, borderRadius: '5px', border: 'none', color: '#fff' }"
                @click="sendCode"
                :disabled="waitCode"
                native-type="button"
            >
              {{ sendCodeText }}
            </van-button>
          </template>
          <template #label>
            <span>短</span><span>信</span><span>验</span><span>证</span><span>码</span>
          </template>
        </van-field>
        <div class="tips">
          温馨提示：“我要更新”功能仅支持企业展厅原申报人员手机号登录，发起更新申请；如非原申报人员，请点击“我要参展”重新提交参展资料。
        </div>
        <div class="tips">
          技术支持：<a href="tel:16670256305">16670256305</a>（许工）
        </div>
        <div class="center-vertical" style="padding: 15px">
          <van-button :disabled="loading" :loading="loading" round block type="info" :style="{ background: $store.state.themeInfo.themeColor, border: 'none' }">登录</van-button>
        </div>
      </van-form>
    </template>
  </div>
</template>

<script>
import { Picker } from 'vant';
import { Toast } from 'vant'
export default {
  name: 'user',
  props: ['phone'],
  components: {VanPicker: Picker},
  data() {
    return {
      isHidden: false,
      companySearch: '',
      companyList: [],
      showCompanyList: false,
      selectedCompany: null,
      containsMiceLink: false,
      refreshLoading: false,
      userInfoShow: false,
      miceLink: '',
      active: 1,
      tabActive: 0,
      phoneRules: /^(?:(?:\+|00)86)?1[3-9]\d{9}$/,
      loading: false,
      interval: null,
      phoneErrorMsg: '',
      waitCode: false,
      sendCodeText: '获取验证码',
      searchSuccess: false,
      userInfo: {
        code: 'https://h5.sensemice.cn'
      },
      form: {
        phone: '',
        verifyCode: ''
      },
      realPhone :'',
      arrangement: [],
      wzVipJourneys: [],
      vipUserInfo: {},
      shareType: 'normal',
      isSearch: false
    }
  },
  computed: {
    witchComp() {
      if (this.active === 1) {
        return 'myTicket'
      } else if (this.active === 2) {
        return 'Share'
      } else if (this.active === 3) {
        if (this.wzVipJourneys.length > 0) {
          return 'vipJourney'
        } else {
          return 'planList'
        }
      } else {
        return 'myTicket'
      }
    },
    auditStatus() {
      return this.$store.state.miceInfo.isAudit === 1 ? (this.userInfo.auditStatus ? this.userInfo.auditStatus === 1 : false) : true
    }
  },

  watch: {
    phone() {
      if(this.phone) {
        this.isHidden = true
        this.realPhone = this.phone
      }else {
        this.isHidden = false
        this.realPhone = ''
      }
    }
  },
  methods: {
    async searchCompany() {
      if (this.companySearch.length < 2) {
        Toast('请输入至少2个字符进行搜索');
        return;
      }

      try {
        const data = {
          keyword: this.companySearch,
          pageIndex: 1,
          pageSize: 20,
          type: 2,
          secType: 2,
          auditAdmin: false,
          pageSorts: [
            {
              column: 'serialNumber',
              asc: true
            }
          ]
        }
        const result = await this.$http.post(this.$baseURL.index.getEnterprise(), data, 1)

        if (result.code === 200 && result.data && result.data.records) {
          this.companyList = result.data.records.map(company => ({
            text: company.name,
            value: company.id,
            phone: company.phone
          }));

          if (this.companyList.length > 0) {
            this.showCompanyList = true;
          } else {
            Toast('未找到匹配的企业');
          }
        } else {
          Toast(result.message || '未获取到企业数据');
        }
      } catch (error) {
        console.error('搜索企业失败:', error);
        Toast('搜索企业失败，请重试');
      }
    },

    onSelectCompany(company) {
      this.selectedCompany = company;
      this.companySearch = company.text;
      // this.form.phone = company.phone;
      // this.form.phone = this.desensitizePhone(company.phone);
      this.realPhone = company.phone;
      this.showCompanyList = false;
    },

    desensitizePhone(phone) {
      if (!phone || phone.length < 7) return phone;
      return phone.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2');
    },
    onClickLeft() {
      this.$router.go(-1)
    },
    async onSubmit() {
      this.arrangement = []
      this.loading = true
      this.form.miceLink = this.$store.state.miceInfo.miceLink || this.miceLink
      this.form.openId = this.$store.state.userInfo.openid
      let result = await this.$http.post(this.$baseURL.index.loginByCode(), this.form, 1)
      this.loading = false
      if (result.code === 200) {
        console.log(result)
        Toast('登录成功!')
        this.$emit('loginSuccess', result.data)
      } else {
        Toast(result.message)
      }
    },
    async sendCode() {
      console.log(this.form.phone   +  "==" + this.realPhone)
      if(this.form.phone !== this.realPhone){
        this.phoneErrorMsg = "手机号与原企业申报人不一致"
      }else if(this.phoneRules.test(this.form.phone)){
        this.phoneErrorMsg = ''
        this.timeOut()
        await this.$http.post(this.$baseURL.index.sendCode(), {
          phone: this.form.phone
        })
      }else {
        this.phoneErrorMsg = "请填写正确手机号"
      }
    },
    timeOut() {
      let count = 60
      this.waitCode = true
      this.interval = setInterval(() => {
        this.sendCodeText = count + '秒后重试'
        if (count === 0) {
          clearInterval(this.interval)
          this.sendCodeText = '获取验证码'
          this.waitCode = false
        }
        count --
      },1000)
    },
    changeCode(code) {
      this.userInfo.code = code
    },
    switchType(index, type = '') {
      if (type === 'normal') {
        this.shareType = 'normal'
      } else if (type === 'vip') {
        this.shareType = 'vip'
      }
      this.active = index
    },
    clickShare() {
      this.active = 2
    }
  },
  mounted() {
    if (this.$route.params.miceLink) {
      this.miceLink = this.$route.params.miceLink
    }
    if(this.phone){
      this.realPhone = this.phone
      this.isHidden = true
    }
  },
  beforeDestroy() {
    if (this.interval) {
      clearInterval(this.interval)
    }
  }
}
</script>

<style lang="less" scoped>
@themeColor: var(--themeColor);
/deep/.van-field{
  &::before{
    content: ''
  }
}
/deep/.van-field__label{
  color: #222;
  font-size: 13px;
  font-weight: bold;
  margin-right: 0.8rem;
}
/deep/.van-field__control{
  &::-webkit-input-placeholder{
    color: #999;
    font-size: 13px;
  }
}
/deep/.van-field__label{
  position: relative;
  color: #222;
  font-size: 13px;
  font-weight: bold;
  margin-right: 0.8rem;
  width: 70px;
  display: flex;
  justify-content: space-between;
}
.auditing-wraper{
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 10px 15px;
  font-size: 14px;
  color: #666;
  background: #fff;
  /deep/.van-divider{
    width: 100%;
    margin: 5px 0;
  }
  img{
    border-radius: 5px;
    object-fit: cover;
    height: 100px;
    width: 100px;
  }
  .text{
    width: 100%;
    padding: 5px 0;
    .fl-left{
      float: left
    }
    .fl-right{
      float: right;
      color: @themeColor
    }
  }
  .status{
    height: 30px;
    line-height: 30px;
  }
}
/deep/ .van-nav-bar__text,
/deep/ .van-nav-bar__arrow,
/deep/ .van-nav-bar__title{
  color: #fff;
}
/deep/.van-tabs__line{
  background: @themeColor;
}
/deep/ .van-pull-refresh {
  overflow: visible;
}
.van-tabs{
  z-index: 1;
}
.van-sticky{
  z-index: 2001;
}
.ticket-enter,
.ticket-leave-to{
  transform: translateY(50px);
  opacity: 0;
}
.ticket-enter-active,
.ticket-leave-active{
  transition: all .3s ease;
}
.tips {
  font-size: 13px;
  color: #999;
  width: 90%;
  margin: 10px auto 0 auto;
}

/* 修复黑屏问题的样式 */
/deep/ .van-picker {
  background-color: #fff;
}

/deep/ .van-picker__toolbar {
  background-color: #f7f8fa;
}

/deep/ .van-picker__confirm {
  color: @themeColor;
}

/deep/ .van-picker__cancel {
  color: #969799;
}

/deep/ .van-picker-column__item {
  color: #323233;
}

///deep/ .van-picker__frame {
//  background-color: #f7f8fa;
//}

.center-span {
  display: flex;
  align-items: center;
}
</style>